// extracted by mini-css-extract-plugin
export default {"empty":"Empty_empty__85Zgo","div_100":"Empty_div_100__5OkUh"};